var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 72,
    viewBox: "0 0 114 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 62.9226H109.341V63.9541C109.341 68.3897 105.731 72 101.295 72H8.04585C3.61031 72 0 68.3897 0 63.9541V62.9226Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2666 10.6248H94.0746C96.3439 10.6248 98.0975 12.4815 98.0975 14.6477V64.2637H11.1405V14.6477C11.1405 12.3783 12.9972 10.6248 15.2666 10.6248Z",
    fill: "white",
    stroke: "#E5E5E5",
    strokeWidth: 1.8309,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8911 21.6619L11.2435 21.6619L11.2435 14.3467C11.2435 12.6898 12.5867 11.3467 14.2435 11.3467L94.8911 11.3467C96.548 11.3467 97.8911 12.6898 97.8911 14.3467L97.8911 21.6619Z",
    fill: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.937 43.3239C36.7737 38.2809 40.8998 32.7795 46.831 32.7795C52.7622 32.7795 59.5858 35.5302 66.8064 35.5302C80.4741 35.301 90.6705 26.8196 90.6705 26.8196V43.3239H37.8052H33.937Z",
    fill: "#82AA00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.937,
    y: 51.5759,
    width: 22.6934,
    height: 2.06304,
    rx: 1.03152,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.9456,
    y: 51.5759,
    width: 23.7249,
    height: 2.06304,
    rx: 1.03152,
    fill: "#E5E5E5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.937,
    y: 55.7019,
    width: 16.5043,
    height: 2.06304,
    rx: 1.03152,
    fill: "#E5E5E5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66.9456,
    y: 55.7019,
    width: 11.3467,
    height: 2.06304,
    rx: 1.03152,
    fill: "#E5E5E5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.4957,
    y: 26.8196,
    width: 6.18911,
    height: 6.18911,
    rx: 1,
    fill: "#82AA00"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.4957,
    y: 35.0715,
    width: 6.18911,
    height: 6.18911,
    rx: 1,
    fill: "#82AA00"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19.4957,
    y: 43.3237,
    width: 6.18911,
    height: 6.18911,
    rx: 1,
    fill: "#82AA00"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19.4957,
    y: 51.5759,
    width: 6.18911,
    height: 6.18911,
    rx: 1,
    fill: "#82AA00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6136,
    cy: 17.155,
    r: 17.155,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5165 34.8228C91.5911 34.8228 94.4651 34.0208 97.005 32.6172L105.761 41.373C107.565 43.1776 110.64 43.2445 112.511 41.373C114.383 39.5015 114.316 36.4938 112.511 34.6223L103.689 25.9333C105.092 23.3935 105.894 20.5194 105.894 17.4448C105.894 7.68642 98.0075 0 88.5165 0C78.8918 0 71.0717 7.8201 71.0717 17.4448C71.0717 27.0027 78.8918 34.8228 88.5165 34.8228ZM88.5165 1.33677C97.406 1.33677 104.625 8.55532 104.625 17.4448C104.625 26.3343 97.406 33.5529 88.5165 33.5529C79.627 33.4861 72.4084 26.2675 72.4084 17.4448C72.4084 8.55532 79.627 1.33677 88.5165 1.33677Z",
    fill: "#E5E5E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6249 25.1425H82.6352C82.9694 25.1425 83.3036 24.8083 83.3036 24.4741V18.4587C83.3036 18.1245 82.9694 17.7903 82.6352 17.7903H78.6249C78.2907 17.7903 77.9565 18.1245 77.9565 18.4587V24.4741C77.9565 24.8083 78.2239 25.1425 78.6249 25.1425Z",
    fill: "#82AA00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1205 13.978H86.7786C86.3776 13.978 86.1102 14.2454 86.1102 14.6464V24.6722C86.1102 25.0064 86.3776 25.3406 86.7786 25.3406H90.1205C90.4547 25.3406 90.7889 25.0064 90.7889 24.6722V14.6464C90.7889 14.3122 90.5216 13.978 90.1205 13.978Z",
    fill: "#82AA00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7873 25.4147H97.418C97.8537 25.4147 98.1441 25.0681 98.1441 24.7215V10.8589C98.1441 10.443 97.8537 10.1658 97.418 10.1658H93.7873C93.3516 10.1658 93.0612 10.443 93.0612 10.8589V24.7215C93.0612 25.1374 93.3516 25.4147 93.7873 25.4147Z",
    fill: "#82AA00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.680bad7f0784626a2e79a2663b889bd4.svg";
export { ForwardRef as ReactComponent };